<template>
  <div :class="open ? 'faq open' : 'faq'">
    <div class="question" @click="$emit('toggleOpen', index)">
      {{ faq.question }}
    </div>
    <div class="answers" v-html="faq.answer"></div>
  </div>
</template>

<script>
export default {
  name: "FAQ",
  props: ["faq", "index", "open"],
};
</script>

<style lang="scss" >
@import "../styles/styles.scss";

.faq-link {
  text-decoration: underline;
  color: #e95557;
}
.FAQ {
  background-color: #232323;
  h1 {
    color: #fff;
    text-align: left;
    margin: auto auto 0.8em auto;
  }
}
.faq {
  display: block;
  width: 100%;
  padding-bottom: 10px;
  cursor: pointer;
}

.faq::before {
  content: "";
  width: 100%;
  background: #ffffff;
  opacity: 0.2;
  height: 1px;
  display: block;
  margin-bottom: 10px;
}

.faq:last-child::after {
  content: "";
  width: 100%;
  background: #ffffff;
  opacity: 0.2;
  height: 1px;
  display: block;
  margin-top: 15px;
}

.faq .question {
  position: relative;
  color: #fff;
  font-size: 1.5em;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.42;
  padding-right: 2em;
}

.faq .question::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -0px;
  transform: translateY(-50%) rotate(0deg);
  width: 12px;
  height: 12px;
  background-image: url("../assets/icon-plus.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all 0s linear;
}

.faq .question::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -0px;
  transform: translateY(-50%) rotate(0deg);
  width: 12px;
  height: 12px;
  background-image: url("../assets/icon-minus.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.faq.open .question {
  margin-bottom: 15px;
}

.faq.open .question::before {
  opacity: 0;
}

.faq .answers {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.5em;
  line-height: 30px;
  font-weight: 300;
  letter-spacing: 0.42px;
  max-height: 0px;
  margin-right: 64px;
  overflow-y: hidden;
  cursor: text;
}

.faq.open .answers {
  opacity: 1;
  padding-bottom: 10px;
  max-height: 1000px;
}

@media screen and (max-width: 769px) {
  .FAQ-container {
    padding: 6.25em 1.5em;
  }
  .faq {
    .question,
    .answers {
      margin-right: 20px;
      font-size: 1.2em;
    }
    .question::before,
    .answers::before,
    .question::after,
    .answers::after {
      right: -21px;
    }
  }
}
@media screen and (max-width: 450px) {
  .faq {
    .question,
    .answers {
      line-height: 16.91px;
      font-size: 0.8125rem;
    }
  }
}
</style>